import React from "react";
import { Box } from "@mui/material";

export function MainSetting() {
  return (
    <Box style={{ marginLeft: "200px" }}>
      <h2>Main Setting Page</h2>
    </Box>
  );
}
